const InfoSite = require("@/modules/infos/components/InfoSite").default;

const InfoRoutes = [
  {
    name: "about",
    path: "/info",
    component: InfoSite,
    meta: {
      name: "Info",
      header: false,
      footer: false,
      back: true,
    },
  },
  {
    name: "infos",
    path: "/infos",
    component: InfoSite,
    meta: {
      requiresAuth: true,
      name: "Info",
    },
  },
];
const InfoInfoRoutes = [];

const InfoBaseDataRoutes = [];

export { InfoRoutes, InfoInfoRoutes, InfoBaseDataRoutes };
